<template>
  <div class="mt-5">
    <v-row>
      <v-col>
        <v-autocomplete
          v-model="selected_year"
          :items="years"
          :item-value="(item) => item['year']"
          :item-text="(item) => objectTranslatorLowerCase(item, 'year')"
          outlined
          dense
          :label="$t('config_teach_table.year')"
          hide-details
        />
      </v-col>
      <v-col>
        <v-autocomplete
          v-model="selected_semester"
          :items="semesters"
          outlined
          dense
          :label="$t('config_teach_table.semester')"
          hide-details
        />
      </v-col>
    </v-row>
    <autocomplete
      :data="faculties"
      :label="$t('config_teach_table.faculty')"
      data_id="FACULTY_ID"
      data_name="NAME"
      :selected_value="selected_faculty"
      @update_selected_value="(val) => (selected_faculty = val)"
      :search_all_label="$t('teach_table.select_all_faculty')"
      :select_searh_all="search_all_faculty"
      @update_select_search_all_value="(val) => (search_all_faculty = val)"
      :can_select_all="true"
      :lower_case="false"
    />
    <autocomplete
      :data="subject_owners"
      :label="$t('config_teach_table.course_category')"
      data_id="TEACH_TABLE_SUBJECT_OWNER_ID"
      data_name="TEACH_TABLE_SUBJECT_OWNER_NAME_MAIN_PAGE"
      :selected_value="selected_subject_owner_id"
      @update_selected_value="(val) => (selected_subject_owner_id = val)"
      :can_select_all="false"
      :lower_case="false"
    />

    <v-divider class="mt-2"></v-divider>
    <v-btn
      block
      large
      color="blue"
      class="mt-3 white--text"
      :disabled="!searchButtonEnable"
      v-on:click="submit"
      >{{ $t("teach_table.search") }}
    </v-btn>
  </div>
</template>

<script>
import Autocomplete from "./components/Autocomplete.vue";
import { objectTranslatorLowerCase } from "@/helper/translator";

export default {
  components: { Autocomplete },
  name: "TeachTableSelectorByCategory",
  props: {
    years: Array,
    semesters: Array,
    faculties: Array,
    subject_owners: Array,
  },
  data: () => ({
    selected_year: null,
    selected_semester: null,
    selected_faculty: null,
    selected_subject_owner_id: null,
    search_all_faculty: false,
  }),
  computed: {
    searchButtonEnable() {
      return (
        this.selected_year &&
        this.selected_semester &&
        (this.selected_faculty || this.search_all_faculty) &&
        this.selected_subject_owner_id
      );
    },
  },
  methods: {
    objectTranslatorLowerCase,
    submit() {
      let routeData = this.$router.resolve({
        name: "teach_table",
        query: {
          mode: "by_subject_owner_id",
          selected_year: this.selected_year,
          selected_semester: this.selected_semester,
          selected_faculty: this.selected_faculty,
          search_all_faculty: this.search_all_faculty,
          selected_subject_owner_id: this.selected_subject_owner_id,
          search_all_department: true,
          search_all_curriculum: true,
          search_all_branch: true,
          search_all_class_year: true,
        },
      });
      window.open(routeData.href, "_blank").focus();
    },
  },
  watch: {
    search_all_faculty(val) {
      if (val) {
        this.selected_faculty = null;
      }
    },
  },
};
</script>

<style></style>
